import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { pagingMarketing, getMarketingById, getAllMarketing, saveMarketing, deleteMarketing } from 'app/services/MarketingService';
import { Marketing } from "app/common/Model/Marketing";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class MarketingStore {
    listAllMarketing = [];
    searchMarketing = new SearchObject();
    pageMarketing = null;
    selectedMarketing = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteMarketing = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllMarketing = () => {
        if (this.listAllMarketing?.length === 0) {
            getAllMarketing()
                .then(({ data }) => this.listAllMarketing = data)
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingMarketing = () => {
        pagingMarketing(this.searchMarketing)
            .then(({ data }) => {
                this.pageMarketing = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchMarketing) => {
        this.searchMarketing = checkSearchObject(this.searchMarketing, searchMarketing);
        this.pagingMarketing();
    }

    handleOpenFormCreateOrEdit = (marketingId) => {
        if (Boolean(marketingId)) {
            getMarketingById(marketingId)
                .then(({ data }) => {
                    this.selectedMarketing = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedMarketing = new Marketing();
            this.openFormCreateOrEdit = true;
        }
    }

    saveMarketing = (marketing) => {
        return saveMarketing(marketing).then(() => {
            this.selectedMarketing = null;
            toast.success("Lưu bản ghi thành công!");
            this.handleClosePopup();
            this.pagingMarketing();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin chiến dịch có lỗi");
            })
    }

    handleDeleteMarketing = (marketing) => {
        this.selectedMarketing = { id: marketing?.id };
        this.openConfirmDeleteMarketing = true;
    }

    handleConfirmDeleteMarketing = () => deleteMarketing(this?.selectedMarketing?.id)
        .then(() => {
            if (this.searchMarketing.pageIndex > 1 && this.pageMarketing.content.length === 1) {
                this.searchMarketing.pageIndex -= 1;
            }
            toast.success("Xóa chiến dịch thành công!")
            this.handleClosePopup();
            this.pagingMarketing();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa chiến dịch có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMarketing = false;
    }

    resetStore = () => {
        this.searchMarketing = new SearchObject();
        this.pageMarketing = null;
        this.selectedMarketing = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMarketing = false;
    }
}